import React, { memo } from 'react'
import { HStack } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import Page from './Page'

const Pagination = ({ totalPages, actualPage, handlePageChange }) => {
  const onPageChange = (newPage) => {
    const numberPage = Number(newPage)
    handlePageChange(numberPage)
  }

  return (
    totalPages && (
      <HStack justifyContent="center" mt="24px">
        <Page
          currentPage={actualPage}
          handlePageClick={onPageChange}
          lastPage={totalPages}
        />
      </HStack>
    )
  )
}

Pagination.propTypes = {
  actualPage: PropTypes.number,
  handlePageChange: PropTypes.func,
  totalPages: PropTypes.number,
}

export default memo(Pagination)
